/*
 * Copyright (c) Dito Technologies
 */

import React, {useState} from "react"
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import {useParams} from "react-router-dom";
import {PiecePlayQuery} from "ui/feature/piece-play/__generated__/PiecePlayQuery.graphql";
import query from "./PiecePlayQuery";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import PiecePlayBody from "ui/feature/piece-play/PiecePlayBody";
import PiecePlayMIDIStatus from "ui/feature/piece-play/PiecePlayMIDIStatus";

const PiecePlay: React.FC = () => {
    const params = useParams();
    const pieceId = params.piece_id ?? "";
    const [pieceName, setPieceName] = useState<string | null>(null);

    return (
        <ContentWrapper>
            <Header1>Play <i>{pieceName ?? "Piece"}</i></Header1>
            <PiecePlayMIDIStatus/>
            <QueryRenderer<PiecePlayQuery>
                environment={environment}
                query={query}
                variables={{piece_id: pieceId}}
                render={({error, props}) => {
                    if (error) {
                        return <ErrorSection/>;
                    } else if (props) {
                        setPieceName(props.music_viewer.piece.name)
                        return <PiecePlayBody piece={props.music_viewer.piece}/>;
                    } else {
                        return <LoadingSection/>;
                    }
                }}
            />
        </ContentWrapper>
    )
}

export default PiecePlay;